import styled from "@emotion/styled";
import { useState } from "react";

const DEFAULT_SIZE = 150;
const DEFAULT_COLOR = "#1b458b";
const DEFAULT_BG_COLOR = "#ffffff";

const CustomCircleChart = ({
  percentage,
  size,
  color,
  bgColor,
}: {
  percentage: number;
  size?: number;
  color?: string;
  bgColor?: string;
}) => {
  const degrees = Math.round((percentage / 100) * 360);

  const PieContainer = styled("div")(
    ({ theme }) => `
  height: ${size || DEFAULT_SIZE}px;
  width: ${size || DEFAULT_SIZE}px;
  position: relative;
  `
  );

  const PieBackground = styled("div")(
    ({ theme }) => `
    position: absolute;
    width: ${size || DEFAULT_SIZE}px;
    height: ${size || DEFAULT_SIZE}px;
    border-radius: 100%;
    box-shadow: 0px 0px 1px rgba(0, 0, 0, 0.5);
  `
  );

  const Hold1 = styled("div")(
    ({ theme }) => `
    position: absolute;
    width: ${size || DEFAULT_SIZE}px;
    height: ${size || DEFAULT_SIZE}px;
    border-radius: 100%;
    clip: rect(0px, ${size || DEFAULT_SIZE}px, ${size || DEFAULT_SIZE}px, ${
      (size || DEFAULT_SIZE) / 2
    }px);
  `
  );

  const Pie1 = styled("div")(
    ({ theme }) => `
    transition: all 1s;
    position: absolute;
    width: ${size || DEFAULT_SIZE}px;
    height: ${size || DEFAULT_SIZE}px;
    border-radius: 100%;
    clip: rect(0px, ${(size || DEFAULT_SIZE) / 2}px, ${
      size || DEFAULT_SIZE
    }px, 0px);
    transform: rotate(${Math.min(180, degrees)}deg);
    background-color: ${color || DEFAULT_COLOR};
  `
  );

  const Hold2 = styled("div")(
    ({ theme }) => `
    position: absolute;
    width: ${size || DEFAULT_SIZE}px;
    height: ${size || DEFAULT_SIZE}px;
    border-radius: 100%;
    clip: rect(0px, ${size || DEFAULT_SIZE}px, ${size || DEFAULT_SIZE}px, ${
      (size || DEFAULT_SIZE) / 2
    }px);
    transform: rotate(180deg);
  `
  );

  const Pie2 = styled("div")(
    ({ theme }) => `
    transition: all 1s;
    position: absolute;
    width: ${size || DEFAULT_SIZE}px;
    height: ${size || DEFAULT_SIZE}px;
    border-radius: 100%;
    clip: rect(0px, ${(size || DEFAULT_SIZE) / 2}px, ${
      size || DEFAULT_SIZE
    }px, 0px);
    background-color: ${color || DEFAULT_COLOR};
    transform: rotate(${Math.max(0, degrees - 180)}deg);
  `
  );

  const InnerCircle = styled("div")(
    ({ theme }) => `
    position: absolute;
    width: ${(size || DEFAULT_SIZE) * 0.8}px;
    height: ${(size || DEFAULT_SIZE) * 0.8}px;
    background-color: ${bgColor || DEFAULT_BG_COLOR};
    border-radius: 100%;
    top: ${(size || DEFAULT_SIZE) * 0.1}px;
    left: ${(size || DEFAULT_SIZE) * 0.1}px;
    box-shadow: 0px 0px 0px rgba(0, 0, 0, 0.5) inset;
    color: white;
    display: flex;
    align-items: center;
    justify-content: center;
  `
  );

  const Content = styled("div")(
    ({ theme }) => `
    display: block;
    width: ${(size || DEFAULT_SIZE) * 0.8}px;
    top: ${(size || DEFAULT_SIZE) * 0.2};
    left: 0;
    text-align: center;
    color: ${color || DEFAULT_COLOR};
    font-size: ${(size || DEFAULT_SIZE) * 0.26}px;
    font-weight: 700;
  `
  );

  return (
    <PieContainer>
      <PieBackground></PieBackground>
      <Hold1>
        <Pie1></Pie1>
      </Hold1>
      <Hold2>
        <Pie2></Pie2>
      </Hold2>
      <InnerCircle>
        <Content>{`${percentage}%`}</Content>
      </InnerCircle>
    </PieContainer>
  );
};

export default CustomCircleChart;
